import getProperty from 'lodash-es/get';
import setProperty from 'lodash-es/set';
import {i18n} from 'mc/lib';
import * as TypSubjektu from 'mc/lib/api/gen/proxioapi/TypSubjektu';
import {localUTCToDate, removeTime} from 'mc/lib/utils/commons';

export function getTypSubjektu(zukpSubjekt) {
    return zukpSubjekt && zukpSubjekt.subjekt && zukpSubjekt.subjekt.typSubjektu || null;
}

export function formatSubjekt(zukpSubjekt) {
    if (zukpSubjekt) {
        const {subjekt} = zukpSubjekt;
        if (subjekt) {
            switch (subjekt.typSubjektu) {
                case TypSubjektu.FO:
                    return subjekt.jmeno + ' ' + subjekt.prijmeni;

                case TypSubjektu.FOP:
                case TypSubjektu.PO:
                    return subjekt.nazev;
            }
        }
    }
    return null;
}

export function validateDatumNarozeni(values, path, errors) {
    const datumNarozeni = getProperty(values, path);
    if (datumNarozeni && localUTCToDate(datumNarozeni) > removeTime(new Date())) {
        setProperty(errors, path, i18n('global.error.notInPast'));
    }
}
